import { Box, Typography } from '@mui/material';
import tokens from '@verifime/design-tokens';
import { DocumentType, TIdentityDocumentType } from '@verifime/utils';
import { DOCUMENT_INSTRUCTIONS } from './constant';

export default function DocumentInstructions({
  documentType,
  dataTestId,
}: Readonly<{
  documentType: TIdentityDocumentType;
  dataTestId?: string;
}>) {
  if (!(documentType in DOCUMENT_INSTRUCTIONS)) {
    return null;
  }

  if (documentType === DocumentType.DriverLicence) {
    return (
      <Box data-testid={dataTestId} data-component="DocumentInstructions" sx={{ width: '100%' }}>
        <Typography
          variant="body1"
          /* TODO: Change to tokens once we have a design token for this */
          sx={{ fontSize: tokens.spacingLg, lineHeight: '150%', letterSpacing: '0.15px' }}
        >
          {DOCUMENT_INSTRUCTIONS[DocumentType.DriverLicence].main}
        </Typography>
        <Typography
          variant="body1"
          /* TODO: Change to tokens once we have a design token for this */
          sx={{ fontSize: tokens.spacingLg, lineHeight: '150%', letterSpacing: '0.15px' }}
        >
          <b>Note:</b> {DOCUMENT_INSTRUCTIONS[DocumentType.DriverLicence].note}
        </Typography>
      </Box>
    );
  }

  const instructions = DOCUMENT_INSTRUCTIONS[documentType as keyof typeof DOCUMENT_INSTRUCTIONS];
  return typeof instructions === 'string' ? (
    <Box data-testid={dataTestId} data-component="DocumentInstructions" sx={{ width: '100%' }}>
      <Typography variant="body1">{instructions}</Typography>
    </Box>
  ) : null;
}
